import type { Skill } from '../skillsData';

export const cryptoskillSocialData: Skill[] = [
  {
    id: 'cast-mind',
    name: 'cast-mind',
    author: 'CastMind',
    authorHandle: '@castmind',
    tag: 'Skill',
    category: 'social',
    description: 'Farcaster native AI content generation. Create, schedule, and optimize casts on the decentralized social protocol with engagement analytics.',
    downloads: 12400,
    stars: 934,
    installCommand: '> install the cast-mind skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/cast-mind',
    usageExample: '> draft new cast\n> schedule posts\n> analyze engagement',
    detailedDescription: 'CastMind is an AI-powered content creation tool for Farcaster. Generate engaging casts optimized for the decentralized social graph, schedule posts for optimal timing based on follower activity patterns, and analyze engagement metrics to refine content strategy for maximum reach and interaction on the Farcaster protocol.',
  },
  {
    id: 'castmind-social-intelligence',
    name: 'castmind-social-intelligence',
    author: 'CastMind',
    authorHandle: '@castmind',
    tag: 'Skill',
    category: 'social',
    description: 'Social intelligence platform for Farcaster. Trend detection, influencer mapping, and sentiment analysis across the decentralized social graph.',
    downloads: 9800,
    stars: 745,
    installCommand: '> install the castmind-social-intelligence skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/castmind-social-intelligence',
    usageExample: '> detect trends\n> map influencers\n> analyze sentiment',
    detailedDescription: 'CastMind Social Intelligence provides advanced analytics for the Farcaster ecosystem. Detect emerging trends before they peak by monitoring cast velocity and engagement acceleration, map influence networks to identify key opinion leaders, and analyze community sentiment across channels with real-time natural language processing.',
  },
  {
    id: 'castmind-social',
    name: 'castmind-social',
    author: 'CastMind',
    authorHandle: '@castmind',
    tag: 'Skill',
    category: 'social',
    description: 'Comprehensive Farcaster social management. Profile optimization, channel discovery, community engagement, and growth automation.',
    downloads: 15600,
    stars: 1167,
    installCommand: '> install the castmind-social skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/castmind-social',
    usageExample: '> optimize profile\n> discover channels\n> automate engagement',
    detailedDescription: 'CastMind Social is a complete Farcaster social media management suite. Optimize your profile for discovery and engagement, discover relevant channels aligned with your interests and expertise, and automate community engagement through intelligent replies, reactions, and recasts that build authentic follower relationships.',
  },
  {
    id: 'castmind-web3-social',
    name: 'castmind-web3-social',
    author: 'CastMind',
    authorHandle: '@castmind',
    tag: 'Skill',
    category: 'social',
    description: 'Web3-native social integration. Cross-platform content syndication, NFT-gated community access, and tokenized engagement on Farcaster.',
    downloads: 11200,
    stars: 845,
    installCommand: '> install the castmind-web3-social skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/castmind-web3-social',
    usageExample: '> syndicate content\n> setup NFT gates\n> tokenize engagement',
    detailedDescription: 'CastMind Web3 Social bridges Farcaster with the broader Web3 ecosystem. Syndicate casts to other social platforms and on-chain channels, configure NFT-gated community access where only token holders can participate in special channels, and tokenize engagement through tipping, rewards, and reputation systems built on Farcaster Frames.',
  },
  {
    id: 'castmind',
    name: 'castmind',
    author: 'CastMind',
    authorHandle: '@castmind',
    tag: 'Skill',
    category: 'social',
    description: 'All-in-one Farcaster AI assistant. Content creation, analytics, community management, and monetization for decentralized social growth.',
    downloads: 21300,
    stars: 1589,
    installCommand: '> install the castmind skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/castmind',
    usageExample: '> create content\n> view analytics\n> manage community',
    detailedDescription: 'CastMind is the comprehensive AI assistant for Farcaster. Create viral-worthy content with AI drafting and optimization, access detailed analytics on reach, engagement, and follower growth, manage community interactions at scale with intelligent auto-responses, and explore monetization opportunities through Farcaster Frames and tokenized interactions.',
  },
  {
    id: 'dagny-nostr',
    name: 'dagny-nostr',
    author: 'Dagny Protocol',
    authorHandle: '@dagny_protocol',
    tag: 'Skill',
    category: 'social',
    description: 'Nostr protocol social automation. Note creation, relay management, and decentralized social graph optimization for the censorship-resistant network.',
    downloads: 6700,
    stars: 512,
    installCommand: '> install the dagny-nostr skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/dagny-nostr',
    usageExample: '> create nostr notes\n> manage relays\n> optimize graph',
    detailedDescription: 'Dagny Nostr provides automation for the Nostr decentralized social protocol. Create and schedule notes across multiple relays, manage relay connections for optimal message propagation and redundancy, and optimize your social graph by discovering and following relevant pubkeys based on content similarity and engagement patterns.',
  },
  {
    id: 'farcaster-agent',
    name: 'farcaster-agent',
    author: 'Farcaster AI',
    authorHandle: '@farcaster_ai',
    tag: 'Skill',
    category: 'social',
    description: 'Autonomous Farcaster agent. AI-driven content creation, engagement automation, and community building on the decentralized social protocol.',
    downloads: 18900,
    stars: 1423,
    installCommand: '> install the farcaster-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/farcaster-agent',
    usageExample: '> deploy agent\n> auto-create content\n> build community',
    detailedDescription: 'Farcaster Agent is an autonomous AI for decentralized social media. Deploy an agent that creates contextually relevant casts based on trending topics, automatically engages with your community through intelligent replies and reactions, and grows your follower base through strategic interaction patterns optimized for the Farcaster algorithm and social graph.',
  },
  {
    id: 'farcaster',
    name: 'farcaster',
    author: 'Farcaster Protocol',
    authorHandle: '@farcaster',
    tag: 'Skill',
    category: 'social',
    description: 'Core Farcaster protocol integration. Cast management, frame interactions, warpcast access, and decentralized social graph operations.',
    downloads: 26700,
    stars: 1987,
    installCommand: '> install the farcaster skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/farcaster',
    usageExample: '> publish cast\n> interact with frames\n> manage social graph',
    detailedDescription: 'Farcaster provides core integration with the decentralized social protocol. Publish and manage casts with rich media support, interact with Farcaster Frames for embedded applications and transactions, access Warpcast features, and traverse the decentralized social graph for discovery, following, and engagement operations.',
  },
  {
    id: 'nookplot-social-agent',
    name: 'nookplot-social-agent',
    author: 'NookPlot',
    authorHandle: '@nookplot',
    tag: 'Skill',
    category: 'social',
    description: 'NookPlot social intelligence agent. Community monitoring, narrative tracking, and social signal detection across crypto social platforms.',
    downloads: 7800,
    stars: 587,
    installCommand: '> install the nookplot-social-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/nookplot-social-agent',
    usageExample: '> monitor communities\n> track narratives\n> detect signals',
    detailedDescription: 'NookPlot Social Agent monitors crypto communities across social platforms. Track community sentiment and discussion volume in real-time, identify emerging narratives before they trend, and detect social signals that correlate with price movements — providing actionable intelligence for traders and community managers.',
  },
  {
    id: 'nostr-nak',
    name: 'nostr-nak',
    author: 'Nostr NAK',
    authorHandle: '@nostr_nak',
    tag: 'Skill',
    category: 'social',
    description: 'Nostr Nostr Address Key (NAK) management. Public key operations, relay authentication, and NIP-05 identifier management for the Nostr protocol.',
    downloads: 5400,
    stars: 412,
    installCommand: '> install the nostr-nak skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/nostr-nak',
    usageExample: '> manage pubkeys\n> authenticate relays\n> setup NIP-05',
    detailedDescription: 'Nostr NAK provides public key management for the Nostr protocol. Generate and manage Nostr key pairs, authenticate with relays using NIP-42 authentication, manage NIP-05 identifiers for human-readable names, and handle key rotation and backup strategies for secure decentralized social identity.',
  },
  {
    id: 'nostr-social',
    name: 'nostr-social',
    author: 'Nostr Social',
    authorHandle: '@nostr_social',
    tag: 'Skill',
    category: 'social',
    description: 'Nostr social platform integration. Note publishing, relay discovery, follow graph management, and decentralized messaging on the censorship-resistant protocol.',
    downloads: 11200,
    stars: 845,
    installCommand: '> install the nostr-social skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/nostr-social',
    usageExample: '> publish notes\n> discover relays\n> manage follows',
    detailedDescription: 'Nostr Social provides comprehensive integration with the Nostr decentralized social protocol. Publish notes with encryption and media support, discover and connect to optimal relays for your content, manage your follow graph across the distributed network, and participate in decentralized direct messaging with end-to-end encryption.',
  },
  {
    id: 'nostr-wallet-connect',
    name: 'nostr-wallet-connect',
    author: 'Nostr Wallet',
    authorHandle: '@nostr_wallet',
    tag: 'Skill',
    category: 'social',
    description: 'Nostr Wallet Connect (NWC) integration. Lightning payments over Nostr, wallet authentication, and zapping functionality for social monetization.',
    downloads: 14500,
    stars: 1089,
    installCommand: '> install the nostr-wallet-connect skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/nostr-wallet-connect',
    usageExample: '> connect wallet\n> send lightning payments\n> zap content creators',
    detailedDescription: 'Nostr Wallet Connect enables Lightning payments through the Nostr protocol. Connect your Lightning wallet for authenticated zapping, send satoshi tips to content creators directly from social interactions, and manage payment permissions for seamless social monetization without leaving your Nostr client.',
  },
  {
    id: 'towns-official-bots',
    name: 'towns-official-bots',
    author: 'Towns Protocol',
    authorHandle: '@towns_protocol',
    tag: 'Skill',
    category: 'social',
    description: 'Towns protocol official bot integration. Community automation, membership management, and on-chain social space administration.',
    downloads: 6200,
    stars: 467,
    installCommand: '> install the towns-official-bots skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/towns-official-bots',
    usageExample: '> setup community bot\n> manage memberships\n> administer spaces',
    detailedDescription: 'Towns Official Bots provides bot automation for the Towns on-chain social protocol. Deploy community management bots for welcome messages, role assignment, and moderation, manage token-gated memberships with automatic verification, and administer on-chain social spaces with automated governance and event coordination.',
  },
  {
    id: 'xmtp-agent',
    name: 'xmtp-agent',
    author: 'XMTP Labs',
    authorHandle: '@xmtp_labs',
    tag: 'Skill',
    category: 'social',
    description: 'XMTP messaging agent. Web3-native encrypted messaging, wallet-to-wallet chat automation, and cross-app communication protocols.',
    downloads: 8900,
    stars: 678,
    installCommand: '> install the xmtp-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/xmtp-agent',
    usageExample: '> send encrypted message\n> automate chat responses\n> bridge across apps',
    detailedDescription: 'XMTP Agent enables automated Web3 messaging through the XMTP protocol. Send encrypted wallet-to-wallet messages, automate chat responses and notifications for dApp interactions, and bridge communications across multiple applications using the universal XMTP messaging layer for seamless cross-platform Web3 communication.',
  },
  {
    id: 'xmtp-official-skills',
    name: 'xmtp-official-skills',
    author: 'XMTP Protocol',
    authorHandle: '@xmtp',
    tag: 'Skill',
    category: 'social',
    description: 'Official XMTP protocol skills. Encrypted messaging, group chats, content types, and notification management for Web3 communication infrastructure.',
    downloads: 13400,
    stars: 1012,
    installCommand: '> install the xmtp-official-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/social/xmtp-official-skills',
    usageExample: '> setup encryption\n> create group chat\n> manage notifications',
    detailedDescription: 'XMTP Official Skills provides comprehensive access to the XMTP Web3 messaging protocol. Configure end-to-end encrypted messaging between wallet addresses, create and manage group chats with customizable permissions, define custom content types for rich messaging, and manage notification preferences for optimal communication flow across the decentralized messaging infrastructure.',
  },
];